import { defineMessages } from 'react-intl';

const rawstrings = defineMessages({
    // LOGIN SCREEN ------------------------------

    email: {
        id: 'EMAIL'
    },
    password: {
        id: 'PASSWORD'
    },

    // INVITE YOUR DRIVERS MODAL ----------------------

    showAll: {
        id: 'SHOW_ALL'
    },

    // INVITE YOUR DRIVERS MODAL ----------------------

    onlineManualLink: {
        id: 'ONLINE_MANUAL_URL'
    },

    // EXPORT CSV-PDF COLUMNAMES ----------------------

    columnLicensePlate: {
        id: 'DATA_TABLE_LICENSEPLATE'
    },
    columnLocation: {
        id: 'DATA_TABLE_LOCATION'
    },
    columnStartDate: {
        id: 'DATA_TABLE_START_DATE'
    },
    columnStartTime: {
        id: 'DATA_TABLE_START_TIME'
    },
    columnEndDate: {
        id: 'DATA_TABLE_END_DATE'
    },
    columnEndTime: {
        id: 'DATA_TABLE_END_TIME'
    },
    columnDuration: {
        id: 'DATA_TABLE_DURATION'
    },
    columnCostInEuro: {
        id: 'DATA_TABLE_COST_IN_EURO'
    },
    columnCost: {
        id: 'DATA_TABLE_COST'
    },

    // ABSOLUTE PATH LINKS ------------------------

    parkdWebsiteHomeUrl: {
        id: 'PARKD_WEBSITE_HOME_URL'
    },
    browserDownloadLinkChrome: {
        id: 'BROWSER_DOWNLOAD_LINK_CHROME'
    },
    browserDownloadLinkFirefox: {
        id: 'BROWSER_DOWNLOAD_LINK_FIREFOX'
    },
    browserDownloadLinkSafari: {
        id: 'BROWSER_DOWNLOAD_LINK_SAFARI'
    },
    browserDownloadLinkOpera: {
        id: 'BROWSER_DOWNLOAD_LINK_OPERA'
    }

    //---------------------------------------------
});

export default rawstrings;
